import * as highcharts from "highcharts";
import { Component, h } from "preact";

export type Options = Highcharts.Options;
export interface ChartProps {
  class: string;
  options: Options;
  callback?: (chart: Highcharts.Chart) => void;
}

export class HighChartsPreact extends Component<ChartProps> {
  public componentDidMount() {
    this.update(this.props);
  }
  public componentDidUpdate(props: ChartProps) {
    this.update(props);
  }
  public render() {
    return <div class={this.props.class} />;
  }

  public update(props: ChartProps) {
    const callback = (chart: Highcharts.Chart) => {
      if (undefined !== props.callback) {
        props.callback(chart);
      }

      chart.reflow();
    };

    highcharts.chart(this.base as HTMLElement, props.options, callback);
  }
}
